import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=46e202d0&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=46e202d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e202d0",
  null
  
)

export default component.exports